__turbopack_context__.v({
  "assistant": "grhIRG_assistant",
  "error": "grhIRG_error",
  "hidden": "grhIRG_hidden",
  "message": "grhIRG_message",
  "system": "grhIRG_system",
  "user": "grhIRG_user",
});
